import { useEffect } from 'react';
import { parameterService } from '../services';
import { formKeyGenerator } from '../helpers/utils/formKeyGenerator';
import { useDispatch } from 'react-redux';
import { captureException } from '@sentry/nextjs';
import { fetchFormSuccess } from '../store/managementForm/actions';
import { FormManagementFormat, FormManagementType } from '../constants/formManagement';

const useFetchCmsForm = (
  src: string | string[],
  formType: FormManagementType,
  formFormat: FormManagementFormat
) => {
  const dispatch = useDispatch();

  useEffect(() => {
    parameterService
      .getCmsFormByType(src ?? 'digiroom', formType, formFormat)
      .then((result) => {
        const formKey = formKeyGenerator(src, formType, formFormat);
        dispatch(
          fetchFormSuccess(formKey, {
            ...result?.data,
            isFallback: false,
          })
        );
      })
      .catch((error) => {
        captureException(error);
        console.log(error);
        parameterService
          .getCmsFormByType('digiroom', formType, formFormat)
          .then((res) => {
            const formKeyFallback = formKeyGenerator(src, formType, formFormat);
            dispatch(
              fetchFormSuccess(formKeyFallback, {
                ...res?.data,
                isFallback: true,
              })
            );
          })
          .catch((err) => {
            captureException(err);
            console.log(err);
          });
      });
  }, [src]);
};

export default useFetchCmsForm;
